module.exports = __webpack_public_path__ + "media/sapa_archive/kantro_analysis_header-22bd7ecf.png";